import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import { ImageUploadModal } from '../../../../../components/ImageUploadModal'
import { observer } from 'mobx-react'
import { SmartImage } from '../../../../../components/SmartImage'

interface State {
  isBiggerImageModalOpen: boolean
  showImageUploadModal: boolean
}

interface Props {
  product: any // This can be either a parent product or child product
  width?: number
  className?: string
  imageWrapperStyle?: React.CSSProperties
  iconWrapperStyle?: React.CSSProperties
  iconStyle?: React.CSSProperties
}

@observer
export class ThumbnailImage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isBiggerImageModalOpen: false,
      showImageUploadModal: false,
    }
  }

  removeThumbnailPhoto = (product: any): void => {
    if (window.confirm('Are you sure you want to delete this photo?')) {
      product.setImageUrl(null)
      this.setState({ isBiggerImageModalOpen: false })
    }
  }

  thumbnailStyle = {
    height: '100%',
    width: '100%',
    borderRadius: 5,
    fontSize: '2.3rem',
    color: 'grey',
    cursor: 'pointer',
  }

  render() {
    const { product, width, className, iconStyle, iconWrapperStyle, imageWrapperStyle } = this.props

    return (
      <div className={product.imageUrl ? `${className} image__shadowed` : className}>
        {product.imageUrl ? (
          <div
            style={imageWrapperStyle}
            data-tip
            data-for='thumbnail-photo'
            onClick={() => this.setState({ isBiggerImageModalOpen: true })}
          >
            <SmartImage src={product.imageUrl} width={width} />
            <Tooltip id='thumbnail-photo' place='top' effect='solid'>
              Edit photo
            </Tooltip>

            <Modal
              isOpen={this.state.isBiggerImageModalOpen}
              toggle={() => this.setState({ isBiggerImageModalOpen: false })}
              centered={true}
            >
              <ModalBody>
                <SmartImage src={product.imageUrl} width={500} />
              </ModalBody>
              <ModalFooter>
                <a
                  onClick={() =>
                    this.setState({
                      showImageUploadModal: true,
                      isBiggerImageModalOpen: false,
                    })
                  }
                >
                  Update
                </a>
                <a onClick={() => this.removeThumbnailPhoto(product)}>Remove</a>
              </ModalFooter>
            </Modal>
          </div>
        ) : (
          <div
            style={iconWrapperStyle}
            onClick={() => this.setState({ showImageUploadModal: true })}
          >
            <i
              data-tip
              data-for='thumbnail-photo-placeholder'
              className='fa fa-picture-o'
              style={{
                ...this.thumbnailStyle,
                ...iconStyle,
              }}
            />
            <Tooltip
              id='thumbnail-photo-placeholder'
              place='top'
              effect='solid'
              className='tooltip-with-inital-line-height'
            >
              Add photo
            </Tooltip>
          </div>
        )}

        <ImageUploadModal
          isOpen={this.state.showImageUploadModal}
          onHide={() => this.setState({ showImageUploadModal: false })}
          onUpload={(object) => {
            product.setImageUrl(object.imageUrl)
            this.setState({ showImageUploadModal: false })
          }}
        />
      </div>
    )
  }
}
